
import React, { useEffect, useState } from 'react';
import { getURL, postAPI } from '../../app/api';
import { store } from '../../app/store';
import { canAccess } from '../../app/permission';

export default function Sidebar() {
  const [TempFormData, setTempFormData] = useState({});
  const store_data = JSON.parse(store());
  const [API_URL, setAPIURL] = useState("");
  const [Access, setAccess] = useState(
    store_data?.role === 'ADMIN' || store_data?.role === 'EMPLOYEE'
  );
  const [permissions, setPermissions] = useState([]);
  const [page, setPage] = useState([]);

  useEffect(() => {
    setPage(window.location.pathname.split('/'));
  }, [window])

  console.log(page)

  const fetchURL = async () => {
    const URL = await getURL();
    setAPIURL(URL);
  };

  const fetchOrganizationData = async () => {
    try {
      const filter = { id: store_data?.org_id }
      const response = await postAPI("/organization/fetchSingle", {...filter, user: store_data});
      setTempFormData({
        ...TempFormData,
        ...response?.data[0]
      })
    } catch (e) {
      console.log("Exception Error: ", e?.response?.data?.error)
    }
  }


  useEffect(() => {
    fetchOrganizationData();
    fetchURL();
    // Fetch permissions for employee
    const fetchPermissions = async () => {
      if (store_data?.role === 'EMPLOYEE') {
        console.log('🔑 Store data:', store_data);
        const user_id = store_data?.user_id || store_data?.id;
        console.log('👤 User ID:', user_id);
        
        const response = await postAPI('/users/get-permissions', { 
          user_id: user_id,
          user: store_data 
        });
        console.log('📋 Permissions loaded:', response);
        if (response?.status === 1) {
          setPermissions(response.data || []);
          console.log('✅ Permissions set:', response.data);
        } else {
          console.error('❌ Permission load failed:', response?.error);
          setPermissions([]);
        }
      }
    };
    fetchPermissions();
  }, []);
  
  // Helper for permission check (module, page, action)
  const canShowMenu = (module, page, action = 'VIEW') => {
    console.log(`🔍 Checking permission - Module: ${module}, Page: ${page}, Action: ${action}`);
    console.log(`👤 User role: ${store_data?.role}`);
    
    if (store_data?.role === 'ADMIN') {
      console.log('✅ Admin - Full access');
      return true;
    }
    
    if (store_data?.role === 'EMPLOYEE') {
      console.log('🔐 Employee - Checking permissions:', permissions);
      const hasAccess = canAccess({ user: store_data, permissions, module, page, action });
      console.log(`${hasAccess ? '✅' : '❌'} Access ${hasAccess ? 'granted' : 'denied'}`);
      return hasAccess;
    }
    
    console.log('❌ No access - Unknown role');
    return false;
  };


  return (
    <>
      <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
        <div className="app-brand demo">
          <a href="/Admin" className="app-brand-link">
            <span className="app-brand-logo demo">
              {/* <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.00172773 0V6.85398C0.00172773 6.85398 -0.133178 9.01207 1.98092 10.8388L13.6912 21.9964L19.7809 21.9181L18.8042 9.88248L16.4951 7.17289L9.23799 0H0.00172773Z"
                  fill="#7367F0"
                />
                <path
                  opacity="0.06"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.69824 16.4364L12.5199 3.23696L16.5541 7.25596L7.69824 16.4364Z"
                  fill="#161616"
                />
                <path
                  opacity="0.06"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.07751 15.9175L13.9419 4.63989L16.5849 7.28475L8.07751 15.9175Z"
                  fill="#161616"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.77295 16.3566L23.6563 0H32V6.88383C32 6.88383 31.8262 9.17836 30.6591 10.4057L19.7824 22H13.6938L7.77295 16.3566Z"
                  fill="#7367F0"
                />
              </svg> */}
              <img src={`${API_URL}/${TempFormData?.organization_logo}`} style={{width: '100%'}} />
            </span>
            {/* <span className="app-brand-text demo menu-text fw-bold">Vuexy</span> */}
          </a>

          {/* <a href="javascript:void(0);" className="layout-menu-toggle menu-link text-large ms-auto">
            <i className="ti menu-toggle-icon d-none d-xl-block ti-sm align-middle"></i>
            <i className="ti ti-x d-block d-xl-none ti-sm align-middle"></i>
          </a> */}
        </div>

        <div className="menu-inner-shadow"></div>

        <ul className="menu-inner py-1">
          {/* <!-- Apps & Pages --> */}
          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Nevigation</span>
          </li>
          {
            canShowMenu('GENERAL', 'Dashboard', 'VIEW') && (
              <li className={`${(page.length == 2 || (page.length == 3 && page[2] == 'Dashboard')) ? "active" : ""} menu-item`}>
                <a href="/Admin/Dashboard" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Dashboard">Dashboard</div>
                </a>
              </li>
            )
          }
          {/* <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Settings</span>
          </li> */}
          <li className={`${page.length > 2 && page[2] == 'Setting' ? "active open" : ""} menu-item`}>
            <a href="/Admin/Setting/General" className="menu-link menu-toggle">
              <div data-i18n="Setting">Setting</div>
            </a>
            <ul className="menu-sub">
              {
                canShowMenu('SETTINGS', 'General', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'General' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/General" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-mail"></i>
                      <div data-i18n="General">General</div>
                    </a>
                  </li>
                )
              }
              {
                canShowMenu('ADMIN', 'Users', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'Users' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/Users" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-users"></i>
                      <div data-i18n="Users">Users</div>
                    </a>
                  </li>
                )
              }
              {
                canShowMenu('SETTINGS', 'SMTPSMS', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'SMTPSMS' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/SMTPSMS" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-mail"></i>
                      <div data-i18n="Mail">Mail</div>
                    </a>
                  </li>
                )
              }
              {
                canShowMenu('SETTINGS', 'Gateway', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'Gateway' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/Gateway" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-mail"></i>
                      <div data-i18n="Gateway">Gateway</div>
                    </a>
                  </li>
                )
              }
              {
                canShowMenu('SETTINGS', 'Coupons', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'Coupons' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/Coupons" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-mail"></i>
                      <div data-i18n="Coupons">Coupons</div>
                    </a>
                  </li>
                )
              }
              {
                canShowMenu('SETTINGS', 'Taxes', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'Taxes' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/Taxes" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-mail"></i>
                      <div data-i18n="Taxes">Taxes</div>
                    </a>
                  </li>
                )
              }
              {
                canShowMenu('SETTINGS', 'AdditionalCharges', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'AdditionalCharges' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/AdditionalCharges" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-mail"></i>
                      <div data-i18n="Additional Charges">Additional Charges</div>
                    </a>
                  </li>
                )
              }
              {
                canShowMenu('SETTINGS', 'NoticeBoard', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'NoticeBoard' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/NoticeBoard" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-mail"></i>
                      <div data-i18n="Notice Board">Notice Board</div>
                    </a>
                  </li>
                )
              }
              {
                canShowMenu('EXAM', 'AdminExams', 'VIEW') && (
                  <li className={`${page.length == 4 && page[3] == 'Exams' ? "active" : ""} menu-item`}>
                    <a href="/Admin/Setting/Exams" className={"menu-link"}>
                      <i className="menu-icon tf-icons ti ti-mail"></i>
                      <div data-i18n="Exams">Exams</div>
                    </a>
                  </li>
                )
              }
            </ul>
          </li>
          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Manage Users</span>
          </li>
          {/* {
            canShowMenu('FINANCE', 'WalletEarnings', 'VIEW') && (
              <li className={`${page.length == 3 && page[2] == 'Earnings' ? "active" : ""} menu-item`}>
                <a href="/Admin/Earnings" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Earnings">Earnings</div>
                </a>
              </li>
            )
          } */}
          {/* {
            canShowMenu('FINANCE', 'WalletWithdrawals', 'VIEW') && (
              <li className={`${page.length == 3 && page[2] == 'WithdrawalRequest' ? "active" : ""} menu-item`}>
                <a href="/Admin/WithdrawalRequest" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Withdrawal Request">Withdrawal Request</div>
                </a>
              </li>
            )
          } */}
          {
            canShowMenu('SETTINGS', 'Customers', 'VIEW') && (
              <li className={`${page.length == 3 && page[2] == 'Customers' ? "active" : ""} menu-item`}>
                <a href="/Admin/Customers" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Students">Students</div>
                </a>
              </li>
            )
          }
          {
            canShowMenu('BOOKS', 'Books', 'VIEW') && (
              <li className={`${page.length == 3 && page[2] == 'Books' ? "active" : ""} menu-item`}>
                <a href="/Admin/Books" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Books">Books</div>
                </a>
              </li>
            )
          }
          {
            canShowMenu('QUERIES', 'Queries', 'VIEW') && (
              <li className={`${page.length == 3 && page[2] == 'Queries' ? "active" : ""} menu-item`}>
                <a href="/Admin/Queries" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Queries">Queries</div>
                </a>
              </li>
            )
          }
          {
            canShowMenu('REFERRALS', 'Referrals', 'VIEW') && (
              <li className={`${page.length == 3 && page[2] == 'Referrals' ? "active" : ""} menu-item`}>
                <a href="/Admin/Referrals" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Referrals">Referrals</div>
                </a>
              </li>
            )
          }
          {
            canShowMenu('SUPPORTTICKETS', 'SupportTickets', 'VIEW') && (
              <li className={`${page.length == 3 && page[2] == 'SupportTickets' ? "active" : ""} menu-item`}>
                <a href="/Admin/SupportTickets" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Support Tickets">Support Tickets</div>
                </a>
              </li>
            )
          }
          {/* {
            canShowMenu('LiveMonitoring', 'view') && (
              <li className={`${page.length == 3 && page[2] == 'LiveMonitoring' ? "active" : ""} menu-item`}>
                <a href="/Admin/LiveMonitoring" className={"menu-link"}>
                  <i className="menu-icon tf-icons ti ti-mail"></i>
                  <div data-i18n="Live Monitoring">Live Monitoring</div>
                </a>
              </li>
            )
          } */}
        </ul>
      </aside>
    </>
  )
}
